import {
  WebGLRenderer,
  Scene,
  Camera,
  Object3D,
  WebGLCubeRenderTarget,
  CubeCamera,
} from "three";

export async function preload( gl: WebGLRenderer, scene: Scene, camera: Camera ): Promise<void> 
{

  const invisible: Object3D[] = [];
  
  scene.traverse((obj: Object3D) => {
    if (!obj.visible) {
      invisible.push(obj);
      obj.visible = true;
    }

    const mesh = obj as any;
    if (mesh.isMesh) {
      ([] as any[]).concat(mesh.material).forEach((mat) => {
        if (!mat) return;

        Object.values(mat).forEach((v: any) => {
          if (v?.isTexture && !v.__webglInit) {
            gl.initTexture(v);
            v.__webglInit = true;
          }
        });
      });
    }
  });

  await gl.compileAsync(scene, camera);

  const rt = new WebGLCubeRenderTarget(128);
  new CubeCamera(0.01, 100000, rt).update(gl, scene);
  rt.dispose();

  invisible.forEach((o) => (o.visible = false));
}
